module.exports = __webpack_public_path__ + "media/images/calendarcheck_icon_active-d2a67fd3.svg";